import AutosizeInput from 'react-input-autosize';
import cx from 'classnames';
import focusNode from 'utils/focusNode';
import Glyph from 'components/Glyph.jsx';
import Input from 'components/Input.jsx';
import React from 'react';

import './styles/MoneyInput.scss';

const CHARACTERISTIC_EMPTY_CHAR = '0';
const CHARACTERISTIC_MAX_DIGIT = 4;
const MANTISSA_MAX_DIGITS = 2;
const CENTS_PER_DOLLAR = 100;

// For the following number: 8.22, characteristic = 8 ; mantissa = 0.22.
// inside this component the mentissa is considered a natural number (22).
// http://www.math-for-all-grades.com/CharacteristicandMantissa.html
class MoneyInput extends React.Component {
  static propTypes = {
    currency: React.PropTypes.oneOf(['USD', 'EUR']),
    initialCentValue: React.PropTypes.number,
    disabled: React.PropTypes.bool,
    autofocus: React.PropTypes.bool,
    border: React.PropTypes.bool,
    onBlur: React.PropTypes.func,
    onChange: React.PropTypes.func,
  };

  static defaultProps = {
    border: false,
    disabled: false,
    onBlur: () => {},
  };

  constructor(props) {
    super(props);
    const { initialCentValue } = props;

    if (!initialCentValue) {
      this.state = {
        characteristic: CHARACTERISTIC_EMPTY_CHAR,
        showMantissa: false,
        mantissa: null,
        focus: false,
      };

      return;
    }

    let dollar = initialCentValue / CENTS_PER_DOLLAR;

    if (dollar % 1) {
      dollar = dollar.toFixed(2);
    }

    const characteristic = dollar.toString().split('.')[0];
    const mantissa = dollar.toString().split('.')[1];

    this.state = {
      characteristic,
      showMantissa: !!mantissa,
      mantissa,
      focus: false,
    };
  }

  componentDidMount() {
    if (this.props.autofocus) {
      this.focusCharacteristic();
    }
  }

  onMantissaChange = (event) => {
    let mantissa = event.target.value.split('').filter(char => {
      return !isNaN(parseInt(char, 10));
    });

    // when backspace is press
    if (event.target.value.length === 0) {
      this.setState({ showMantissa: false }, () => {
        this.refs.characteristic.focus();
      });
    }

    mantissa = mantissa.join('');
    mantissa = mantissa.substring(0, MANTISSA_MAX_DIGITS);

    this.setState({ mantissa }, this.propagateOnChange);
  };

  onCharacteristicChange = (event) => {
    let characteristic = event.target.value.split('').filter(char => {
      return !isNaN(parseInt(char, 10));
    });

    if (event.target.value.includes('.')) {
      this.setState({ showMantissa: true }, () => {
        this.refs.mantissa.focus();
      });
    }

    // when backspace is press
    if (event.target.value.length === 0) {
      characteristic.push(CHARACTERISTIC_EMPTY_CHAR);
    }

    // when first keystroke, remove default default.
    if (characteristic.length === 2 && characteristic[0] === CHARACTERISTIC_EMPTY_CHAR) {
      characteristic.shift();
    }

    characteristic = characteristic.join('');
    characteristic = characteristic.substring(0, CHARACTERISTIC_MAX_DIGIT);

    this.setState({ characteristic }, this.propagateOnChange);
  };

  onCharacteristicClick = (event) => {
    this.focusCharacteristic();
    event.stopPropagation();
  };

  focus = () => {
    focusNode(this.refs.characteristic);
  };

  propagateOnChange = () => {
    if (this.props.onChange) {
      this.props.onChange({
        value: (
          Number(this.state.characteristic) * CENTS_PER_DOLLAR) +
          Number((this.state.mantissa || 0)
        ),
      });
    }
  };

  focusCharacteristic = () => {
    const input = this.refs.characteristic.getInput();
    this.refs.characteristic.focus();

    if (input.value && input.value.length === 1) {
      if (input.setSelectionRange) {
        input.setSelectionRange(1, 1);
      }
    }
  };

  renderCurrencySymbol = () => {
    switch (this.props.currency) {
      case 'USD':
        return <Glyph name="dollar" size="xxlarge" solo />;
      case 'EUR':
        return '€';
      default:
    }
  };

  render() {
    return (
      <div
        onBlur={this.props.onBlur}
        className={cx(this.props.className,
        'MoneyInput', {
          'MoneyInput-empty': this.state.characteristic[0] === CHARACTERISTIC_EMPTY_CHAR,
          'MoneyInput-animation': this.state.animation,
          'MoneyInput-border': this.props.border,
          'MoneyInput-focus': this.state.focus,
        },
      )}>
        <span className="MoneyInput-currencySymbol">
          {this.renderCurrencySymbol()}
        </span>

        <AutosizeInput
          className="MoneyInput-characteristic"
          disabled={this.props.disabled}
          onChange={this.onCharacteristicChange}
          onClick={this.onCharacteristicClick}
          onFocus={() => this.setState({ focus: true })}
          value={this.state.characteristic.toString()}
          placeholder="0"
          onBlur={(event) => {
            const switchedToMantissa = (
              this.state.showMantissa && (
                !this.state.mantissa ||
                this.state.mantissa.length === 0
              )
            );

            if (switchedToMantissa) {
              event.stopPropagation();
              event.preventDefault();
            } else {
              this.setState({ focus: false });
            }
          }}
          ref="characteristic"
        />

        {this.state.showMantissa &&
          <Input
            className="MoneyInput-mantissa"
            disabled={this.props.disabled}
            onChange={this.onMantissaChange}
            onClick={event => event.stopPropagation()}
            value={this.state.mantissa && this.state.mantissa.toString()}
            placeholder="00"
            ref="mantissa"
            onFocus={() => this.setState({ focus: true })}
            onBlur={() => this.setState({ focus: false })}
          />
        }
      </div>
    );
  }
}

export default MoneyInput;



// WEBPACK FOOTER //
// ./src/components/MoneyInput.jsx